import { i18n } from '@lingui/core';

const localeLoaders = {
    en: () => import('../locales/en/messages.mjs'),
    nb: () => import('../locales/nb/messages.mjs'),
    fi: () => import('../locales/fi/messages.mjs'),
    da: () => import('../locales/da/messages.mjs'),
    sv: () => import('../locales/sv/messages.mjs'),
};

const loadAndActivateI18n = async (locale = 'en') => {
    const loader = localeLoaders[locale] || localeLoaders.en;
    const { messages } = await loader();
    i18n.load({ [locale]: messages });
    i18n.activate(locale);
};

export default loadAndActivateI18n;
